import { Component, forwardRef } from '@angular/core';
import { ModelService } from '../../../../Services/model.service';
import { UserActionFeatureSystemsComponent } from '../userAction-featureSystem/userAction-featureSystem.component';
import { StartAction } from '../../../../Model/Dto/StartAction';
import { ValidFeatureService } from '../../../../Services/validFeature.service';
import { TranslateService } from '@ngx-translate/core';
import { CatalogService } from 'app/Services/CatalogManagement/catalog.service';
import { MacroService } from 'app/Services/CatalogManagement/macro.service';
import { JobService } from 'app/Services/job.service';
import { LoginService } from 'app/Services/login.service';
import { UserActionBaseComponent } from '../userAction-base.component';

@Component({
    selector: 'userAction-harmonizeFeatureSystems',
    templateUrl: 'userAction-harmonizeFeatureSystems.component.html',
    providers: [
        { provide: UserActionBaseComponent, useExisting: forwardRef(() => UserActionHarmonizeFeatureSystems) }
    ],
    standalone: false
})
export class UserActionHarmonizeFeatureSystems extends UserActionFeatureSystemsComponent {

  _destFeatureSystemName: string = '';
  featureSystemsWithOrder: any[] = [];
  adaptTemplates: boolean = false;  

  constructor(
    public loginService: LoginService,
    public macroService: MacroService,
    public jobService: JobService,
    public translate: TranslateService,
    public catalogService: CatalogService,
    validFeatureService: ValidFeatureService
  ) {
    super(loginService, macroService, catalogService, validFeatureService);
  }

  async ngOnInit() {
    await super.ngOnInit();
    this.featureSystemsWithOrder = this.featureSystems.sort((a, b) => a.name.localeCompare(b.name));
    this.setOrders();
  }

  setOrders() {
    for (var i = 1; i <= this.featureSystemsWithOrder.length; i++) {
      this.featureSystemsWithOrder[i - 1].order = i;
    }
  }

  parseParameter(parameter: string) {
    if(!parameter)
      return;
    try {
      const parsed = JSON.parse(parameter);
      this.featureSystemsWithOrder = parsed.harmonizeFeatureSystemModels;
      this.adaptTemplates = parsed.adaptTemplates;
    } catch (error) {
      console.error('Invalid JSON string provided:', error);
    }
  }

  createParameterStringAsJsonString() {
    return JSON.stringify({
      harmonizeFeatureSystemModels: this.featureSystemsWithOrder,
      adaptTemplates: this.adaptTemplates
    });
  }
}
